<!--
  name : 김장호
  desc : PDF.js를 이용한 썸네일
  date : 2020-09-29
-->
<template>
  <v-container>
    <v-row no-gutters class="preview-area-con">
      <v-col cols="12" class="preview-area-top ta_center">
        <v-btn color="primary" @click="prevPage">이전</v-btn>
        <span style="padding:0 20px; color:white"> Page: {{pageNum}} / {{totalPageNum}} </span>
        <v-btn color="primary" @click="nextPage">다음</v-btn>
      </v-col>
      <v-col cols="12" class="d-flex justify-center preview-area">
        <canvas id="preview_canvas"></canvas>
      </v-col>
    </v-row>
    <s-loading ref="loading"></s-loading>
  </v-container>
</template>
<script>
export default {
  name: 'pdfPreview',
  components: {
  },
  filters: {
  },
  props: {
    scale: Number
  },
  data () {
    return {
      pdfjsLib: null,
      pdfDoc: null,
      pageNum: 0,
      totalPageNum: 0,
      pageRendering: false,
      pageNumPending: null,
      canvas: null,
      ctx: null
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    open (url) {
      this.url = url
      this.startPdfPreview()
    },
    init () {
      this.pdfjsLib = require('pdfjs-dist/build/pdf.js')
      this.pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry.js')

      this.pdfDoc = null
      this.pageNum = 1
      this.pageRendering = false
      this.pageNumPending = null
      this.canvas = document.getElementById('preview_canvas')
      this.ctx = this.canvas.getContext('2d')
    },
    renderPage (num) {
      this.pageRendering = true
      this.$refs.loading.start('미리보기를 로딩중입니다. 잠시만 기다려주세요.')
      this.pdfDoc.getPage(num).then(page => {
        var viewport = page.getViewport({ scale: this.scale })
        this.canvas.height = viewport.height
        this.canvas.width = viewport.width

        var renderContext = {
          canvasContext: this.ctx,
          viewport: viewport
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(() => {
          this.pageRendering = false
          this.$refs.loading.end()
          if (this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(this.pageNumPending)
            this.pageNumPending = null
          }
        })
      })
    },
    startPdfPreview () {
      this.$refs.loading.start('미리보기를 로딩중입니다. 잠시만 기다려주세요.')
      // this.pdfjsLib.getDocument(this.url)
      this.pdfjsLib.getDocument({
        url: this.url,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.3.200/cmaps/',
        cMapPacked: true,
      }).promise.then(__pdfDoc => {
        this.pdfDoc = __pdfDoc
        this.totalPageNum = this.pdfDoc.numPages
        this.renderPage(this.pageNum)
      })
    },
    nextPage () {
      if (this.pageNum >= this.pdfDoc.numPages) {

        return
      }
      this.pageNum++
      this.queueRenderPage(this.pageNum)
    },
    prevPage () {
      if (this.pageNum <= 1) {
        return
      }
      this.pageNum--
      this.queueRenderPage(this.pageNum)
    },
    queueRenderPage (num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
  }
}
</script>
<style scoped>
</style>
